import { AppCategories } from './AppCategories'

export const AppCategoryNames = {
  [AppCategories.UNSPECIFIED]: 'Unspecified',
  [AppCategories.PRIVACY]: 'Privacy',
  [AppCategories.ASSET_APP]: 'Asset',
  [AppCategories.IDENTITY]: 'Identity',
}
